export default __webpack_public_path__ + "static/media/trekant.06395840.svg";